// src/components/ui/LoadingSpinner.tsx
import React from "react";
import { motion } from "framer-motion";
import { useBranch } from "~/contexts/BranchContext";

interface LoadingSpinnerProps {
  size?: number;
  message?: string;
}

const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({
  size = 16,
  message,
}) => {
  const { theme } = useBranch();
  const spinnerColor = theme?.primaryColor;
  return (
    <div className="flex flex-col items-center justify-center">
      <motion.div
        className="rounded-full border-t-transparent"
        animate={{ rotate: 360 }}
        transition={{
          duration: 1,
          repeat: Infinity,
          ease: "linear",
        }}
        style={{
          width: `${size}rem`,
          height: `${size}rem`,
          borderWidth: `${size / 4}rem`,
          borderStyle: "solid",
          borderLeftColor: spinnerColor,
          borderRightColor: spinnerColor,
          borderBottomColor: spinnerColor,
          borderTopColor: "transparent",
          color: spinnerColor,
          backgroundColor: spinnerColor + "20",
        }}
      />
      {message && <p className="mt-4 text-gray-600">{message}</p>}
    </div>
  );
};

export default LoadingSpinner;
